import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactPixel } from './fbpixel';

const PixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    ReactPixel.pageView(); 
  }, [location.pathname]);

  return null;
};

export default PixelTracker;
